import {NgModule} from '@angular/core';
import {SharedModule} from '../shared/shared.module';
import {DrawingService} from './drawing.service';
import {DrawingDatatableComponent} from './drawing-datatable.component';
import {DrawingFormComponent} from './drawing-form.component';
import {FileModule} from '../file/file.module';
import {Drawing} from './drawing.model';

@NgModule({
  declarations: [
    DrawingDatatableComponent,
    DrawingFormComponent
  ],
  exports: [
    DrawingDatatableComponent,
    DrawingFormComponent
  ],
  imports: [
    SharedModule,
    FileModule
  ],
  providers: [
    DrawingService,
    Drawing
  ]
})
export class DrawingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/drawing/drawing.module.ts